import React from 'react';
import { useRouter } from 'next/router';

import styles from './PageTitle.module.scss';

export default function PageTitle(pageProps) {
  const { locale } = useRouter();
  const subtitle = pageProps.subtitle;

  return (
    <div className={styles.pageTitle}>
      <h1 className={styles.title}>
        {locale == 'fr' ? 'Construire et obtenir un devis' : 'Build & Quote'}
      </h1>
      {subtitle && <h2 className={styles.title}>{subtitle}</h2>}
    </div>
  );
}
